import { Order } from "services/types/orders.type";

import EnumDataSource from "../utils/enum-data-source.util";

export const ORDER_CREATED_STATUS_TYPE = 1;
export const ORDER_SUBMITTED_STATUS_TYPE = 2;
export const ORDER_SHIPPED_STATUS_TYPE = 3;
export const ORDER_DELIVERED_STATUS_TYPE = 4;
export const ORDER_CANCELED_STATUS_TYPE = 99;

const purchaseOrderStatuses = {
  [ORDER_CREATED_STATUS_TYPE]: "To be Ordered",
  [ORDER_SUBMITTED_STATUS_TYPE]: "Ordered - Submitted to Manufacturer",
  [ORDER_SHIPPED_STATUS_TYPE]: "Shipped by Manufacturer",
  [ORDER_DELIVERED_STATUS_TYPE]: "Order Accepted by Clinic",
  [ORDER_CANCELED_STATUS_TYPE]: "Order Canceled"
};

export const PURCHASE_ORDER_STATUSES = new EnumDataSource(
  purchaseOrderStatuses
);

const repairOrderStatuses = {
  [ORDER_CREATED_STATUS_TYPE]: "Repair Requested",
  [ORDER_SUBMITTED_STATUS_TYPE]: "Repair Order sent to Manufacturer",
  [ORDER_SHIPPED_STATUS_TYPE]: "Shipped by Manufacturer",
  [ORDER_DELIVERED_STATUS_TYPE]: "Order Accepted by Clinic",
  [ORDER_CANCELED_STATUS_TYPE]: "Order Canceled"
};

export const REPAIR_ORDER_STATUSES = new EnumDataSource(repairOrderStatuses);

export const ORDER_PURCHASE_TYPE = 1;
export const ORDER_REPAIR_TYPE = 2;
export const ORDER_EXCHANGE_TYPE = 3;

const orderTypes = {
  [ORDER_PURCHASE_TYPE]: "Purchase",
  [ORDER_REPAIR_TYPE]: "Repair",
  [ORDER_EXCHANGE_TYPE]: "Exchange"
};

export const ORDER_TYPES = new EnumDataSource(orderTypes);

export const QUICK_FILTER_DEFAULT_TYPE: string = "0";
export const QUICK_FILTER_PURCHASE_TYPE: string = "3";
export const QUICK_FILTER_EXCHANGE_TYPE: string = "5";
export const QUICK_FILTER_IN_PROGRESS_TYPE: string = "1";
export const QUICK_FILTER_DELIVERED_TYPE: string = "2";
export const QUICK_FILTER_REPAIR_IN_PROGRESS_TYPE: string = "6";
export const QUICK_FILTER_REPAIR_COMPLETED_TYPE: string = "7";

const ordersQuickFiltersType = {
  [QUICK_FILTER_IN_PROGRESS_TYPE]: "Orders In Progress",
  [QUICK_FILTER_DELIVERED_TYPE]: "Completed Orders",
  [QUICK_FILTER_PURCHASE_TYPE]: "Purchase",
  [QUICK_FILTER_REPAIR_IN_PROGRESS_TYPE]: "Repairs In Progress",
  [QUICK_FILTER_REPAIR_COMPLETED_TYPE]: "Repairs Completed",
  [QUICK_FILTER_EXCHANGE_TYPE]: "Exchange",
  [QUICK_FILTER_DEFAULT_TYPE]: "All"
};

export const QUICK_FILTER_TYPES = new EnumDataSource(ordersQuickFiltersType);

export const FINAL_ORDER_STATUSES = [ORDER_DELIVERED_STATUS_TYPE];

export const isOrderInFinalState = (order: Order): boolean =>
  order.status != null && FINAL_ORDER_STATUSES.includes(order.status);
